import React from 'react';
import { Col } from '../../../../grid';
import { Span } from '../../../../typography';

const RenderInStock = ({
  inStock,
}) => {
  if (inStock !== '100' && inStock > 0) {
    return (
      <Col xs={12}>
        <Span block fontSize="13px" red paddingTop="5px">
          {inStock} tilbage på lager!
        </Span>
      </Col>
    );
  }
  return (null);
};

// Export
export default RenderInStock;
